<template>
  <div class="row bg-white">
    <div
      v-if="groups && groups.length > 0">
      <div
        v-for="g in groups"
        class="my-card card">
        <div class="card-header">
          <div class="header-card-left pull-left text-bold">
            {{ g.group_name }}
          </div>
        </div>

        <div class="body-card clearfix">
          <div class="col-12 bg-white">
            <div class="row row-cols-4 row-cols-sm-4 h-100">
              <div
                v-for="covan in g.services"
                class="card text-center">
                <service-item :item="covan"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  import rf from '../../communicate/RequestFactory';
  import {errorToaster} from '../../services/ErrorHandler'
  import ServiceItem from './ServiceItem'
  import ServiceItemPaid from './ServiceItemPaid'
  import Dv from '../../communicate/DichVuType'

  export default {
    name: 'Service',
    components: {
      ServiceItemPaid,
      ServiceItem
    },
    data() {
      return {
        groups: []
      }
    },

    mounted () {
      this.loadServices();
    },

    methods: {
      loadServices() {
        rf.getRequest("ServiceRequest").getGroupService().then((res) => {
          if (res.status === 200) {
            this.groups = res.data
          } else {
            errorToaster("Cố vấn Phong Thủy", res.message);
          }
        }).catch(err => {
          errorToaster("Cố vấn Phong Thủy", err.message);
        })
      },

      content(event) {
        if (event.id === Dv.KICH_TAI_LOC) {
          this.$router.push('tai_loc/content');
        } else if (event.id === Dv.NHA_O) {
          this.$router.push('nha_o/content');
        }
      }
    }
  }
</script>

<style scoped>
  .card{
    margin-top: 0;
    border-radius: 0;
    border-collapse: collapse;
  }
  .card-header{
    border-bottom: none;
    color: #fff;
    background-color: #11CA71;
    border-color: #28a745;
    width: 100%;
    border-radius: 0;
  }
  .header-card-right a{
    color: #4CAF50;
    font-size: 0.8rem;
    margin-right:10px ;
  }

  .border-service {
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/service/Service.vue